import { Flex, Spin } from 'antd';
import { createContext, ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { API } from '../api';
interface UserContextProps {
  user?: any;
  getCustomer: any;
  getBranch: any;
  onChange: any;
  isLogisticRole?: boolean;
  isCustomsRole?: boolean;
  isBranchRole?: boolean;
}
export const UserContext = createContext<UserContextProps>({
  onChange: () => {},
  getCustomer: () => {},
  getBranch: () => {},
});

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);

  const fetchUser = useCallback(async () => {
    setLoading(true);
    try {
      const response = await API.get({ apiVersion: 'api' })('/auth/info');
      setUser(response?.result?.member);
    } catch (error) {
      console.debug(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, []);

  const getCustomer = useMemo(() => {
    return user?.customer || null;
  }, [user]);

  const getBranch = useMemo(() => {
    return user?.courierBranch || null;
  }, [user]);
  const isCustomsRole = useMemo(() => {
    return user?.role?.roleCd.toLowerCase() === 'customs' ? true : false;
  }, [user]);
  const isAdminRole = useMemo(() => {
    return user?.role?.roleCd.toLowerCase() === 'admin' ? true : false;
  }, [user]);

  const isBranchRole = useMemo(() => {
    return user?.role?.roleCd.toLowerCase() === 'branch_staff' ? true : false;
  }, [user]);

  const isLogisticRole = useMemo(() => {
    return user?.role?.roleCd.toLowerCase() === 'logistic' ? true : false;
  }, [user]);

  return (
    <UserContext.Provider
      value={{
        user,
        getCustomer,
        getBranch,
        isLogisticRole,
        isBranchRole,
        isCustomsRole,
        onChange: setUser,
      }}
    >
      {loading ? (
        <Flex style={{ width: '100%', height: '100vh' }} align="center" justify="center">
          <Spin />
        </Flex>
      ) : (
        children
      )}
    </UserContext.Provider>
  );
};
